export const css = {
    root: '_5jPvWMGA',
    heading: '_1bofvbGo',
    row: '_3eRwKBwF',
    product: '_2NAPv7rm',
    primary: '_2PHNsguZ',
    secondary: '_3IeEkER_',
    sticky: '_2OxmCQUo',
    leading: '_49UBYrei',
    title: '_3KaVuIRd',
    actions: 'SXlpZfBs',
    trailing: 'RyO_JTHJ',
    spacer: '_2BDPZJA0',
    hamburgerWrapper: '_1znQh-dz',
    hamburger: '_2UXlDle2',
    hamburgerText: '_2SdbIewJ',
    hamburgerMenu: '_1ggySxTQ',
    hamburgerMenuItem: '_2YICljc3',
    quizSelect: '_2RsDaBT6',
    quizSelectBlock: '_10vsuFDo',
    hideCountdownBlock: '_46ipcWRD',
    quizSelectChoice: 'bnGJbpKr',
    quizSelectHidden: '_2UHte48B',
    examCalendar: 'rmLUKBV6',
    home: '_3TY16Tqc',
    selectFadeOut: '_3gRjPraJ',
    ' _key': 'afcpe-theme/afcpe/lcc-app/heading'
};
export default css;
